module.exports = __webpack_public_path__ + "static/media/mediabg.09122802.jpg";